'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _component = require('../component');

var _component2 = _interopRequireDefault(_component);

var _domPatcher = require('../dom-patcher');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @deprecated
 * ControlledComponent is deprecated. Compose with a normal component and controller
 *
 * @example
 * constructor() {
 *   super(...arguments);
 *   this.controller = new ExampleController({store: this});
 *   this.setConfig(`defaultState`, this.controller.defaultState);
 * }
 */

var ControlledComponent = function (_Component) {
  _inherits(ControlledComponent, _Component);

  function ControlledComponent() {
    _classCallCheck(this, ControlledComponent);

    var _this = _possibleConstructorReturn(this, (ControlledComponent.__proto__ || Object.getPrototypeOf(ControlledComponent)).apply(this, arguments));

    _this.controller = _this.getConfig('controller');
    if (!_this.controller) {
      throw Error('"controller" must be set in config of a ControlledComponent');
    }
    // Don't allow component's update directly
    _this._update = _this.update;
    _this.update = function () {
      throw new Error('update() not allowed from component. Use controller');
    };
    _this._updateListener = function () {
      return _this._update();
    };
    _this.controller.subscribeUpdates(_this._updateListener);
    return _this;
  }

  _createClass(ControlledComponent, [{
    key: 'disconnectedCallback',
    value: function disconnectedCallback() {
      if (!this.initialized) {
        return;
      }

      _get(ControlledComponent.prototype.__proto__ || Object.getPrototypeOf(ControlledComponent.prototype), 'disconnectedCallback', this).call(this);
      this.controller.unsubscribeUpdates(this._updateListener);
    }
  }, {
    key: 'attributeChangedCallback',
    value: function attributeChangedCallback(attr) {
      // super.attributeChangedCallback class calls this.update() which will throw an error
      this._updateAttr(attr);
      if (this.initialized) {
        this._update();
      }
    }
  }, {
    key: '_render',
    value: function _render() {
      if (this.shouldUpdate()) {
        try {
          // Pass in $controller to jade.
          // Template should use something like $controller.getDisplayX() to get the state it needs
          this._rendered = this.getConfig('template')({
            $component: this,
            $helpers: this.helpers,
            $controller: this.controller,
            $attr: this.attr.bind(this)
          });
        } catch (e) {
          this.logError('Error while rendering ' + this.toString(), this, e.stack);
        }
      }
      return this._rendered || _domPatcher.EMPTY_DIV;
    }
  }]);

  return ControlledComponent;
}(_component2.default);

exports.default = ControlledComponent;